<template>
    <div>
        <!-- Main Start -->
        <main class="main">
            <!-- Breadcrumb Start -->
            <div class="breadcrumb-wrap">
                <div class="banner">
                    <img class="bg-img bg-top" src="/assets/images/bg/bg-header-001.jpg" alt="banner" />

                    <div class="container-lg">
                        <div class="breadcrumb-box">
                            <div class="heading-box">
                                <h1>Mi Carrito</h1>
                            </div>
                            <ol class="breadcrumb">
                                <li><a href="/">Inicio</a></li>
                                <li>
                                    <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                </li>
                                <li><a href="/shop">Tienda</a></li>
                                <li>
                                    <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                </li>
                                <li class="current"><a href="javascript:void(0)">Carrito</a></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Breadcrumb End -->

            <!-- Cart Section Start -->
            <section class="section-b-space card-page" v-show="!loader">
                <div class="container-lg">
                    <div class="bg-danger p-2 text-white rounded shadow mb-2" style="width: 100%; display: none;">
                        Para que todos puedan aprovechar nuestras ofertas CachaBLACK; cada cliente puede comprar una
                        unidad de cada producto disponible en la promoción.
                    </div>
                    <div class="row g-3 g-md-4 cart">
                        <div class="col-md-7 col-lg-9">
                            <div class="cart-wrap">
                                <div class="items-list">
                                    <table class="table cart-table m-md-0">
                                        <thead>
                                            <tr>
                                                <th class="d-none d-sm-table-cell">PRODUCTO</th>
                                                <th class="d-none d-sm-table-cell">PRECIO</th>
                                                <th class="d-none d-lg-table-cell">CANTIDAD</th>
                                                <th class="d-none d-xl-table-cell">TOTAL</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <!-- v-if="loadingSucursal" -->
                                        <tbody>

                                            <template v-for="(CART, index) in CARTS" :key="CART.uniqd || index">
                                                <tr>
                                                    <td>
                                                        <div class="product-detail">
                                                            <img class="pr-img" 
                                                            :src="CART.imagen || CART.image_url || '/assets/images/placeholder-product.png'"
                                                            alt="CART.title || 'Producto'"
                                                            width="72"
                                                            height="72"
                                                            loading="lazy" 
                                                            />
                                                            <div class="details">
                                                                <h4 class="title-color font-default2">
                                                                    <router-link :to="'/product/' + CART.slug">
                                                                        {{ CART.title }}
                                                                    </router-link>
                                                                </h4>
                                                                <template v-if="CART.is_pc_build">
                                                                    <b style="color: #3b73f1;">PC Builder</b>
                                                                </template>
                                                                <template v-if="CART.kit">
                                                                    <b style="color: #3b73f1;"> <small>KIT: {{
                                                                        CART.kit.name }}</small> </b>
                                                                </template>
                                                                <!-- <span class="sold-by">Sold By: <span>Roger Group</span> </span> -->
                                                                <!-- <span class="size gap-2 d-flex">Size : <span>M</span> </span> -->
                                                                <!-- isNotStockProduct(CART) -->
                                                                <small class="text-danger"
                                                                    v-if="CART.is_not_stock_product">
                                                                    {{ isNotStockProduct(CART) }}
                                                                </small>
                                                                <span class="size gap-2 d-flex d-sm-none">Total :
                                                                    <span>$ {{ CART.total }} </span> </span>
                                                                <div class="d-block d-sm-none"
                                                                    v-if="CART.code_cupon || CART.code_discount || CART.code_offer">

                                                                    <!-- <small class="sold-by" v-if="CART.code_offer">Oferta <span>{{ CART.code_offer }}</span> </small> -->
                                                                    <!-- <br> -->
                                                                    <!-- <small class="sold-by" v-if="CART.type_discount == 1">Descuento : <span>- {{ CART.discount }} %</span> </small>
                                                                <br v-if="CART.type_discount == 1">
                                                                <small class="sold-by" v-if="CART.type_discount == 2">Descuento : <span>- $ {{ CART.discount }} </span> </small>
                                                                <br v-if="CART.type_discount == 2"> -->
                                                                    <small class="sold-by">Antes : <span> $ {{
                                                                        CART.price_unit }} </span> </small>
                                                                    <!-- <br>
                                                                <small class="sold-by" v-if="CART.code_cupon && !CART.code_discount && !CART.code_offer">Cupon: <span>{{ CART.code_cupon }}</span> </small> -->
                                                                    <!-- <small class="sold-by" v-if="CART.code_discount">Descuento: <span>{{ CART.code_discount }}</span> </small> -->
                                                                </div>

                                                                <div class="plus-minus mt-2 d-inline-flex d-lg-none">
                                                                    <a href="javascript:void(0)"
                                                                        @click="minusCart(CART)"> <i class="sub"
                                                                            data-feather="minus"></i> </a>
                                                                    <input 
                                                                    type="number" 
                                                                    :value="CART.quantity" 
                                                                    min="1"
                                                                    :max="MAX_QTY" 
                                                                    @input="enforceMax(CART, $event)"

                                                                
                                                                    />
                                                                    <a href="javascript:void(0)"
                                                                        @click="plusCart(CART)"> <i class="add"
                                                                            data-feather="plus"></i> </a>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="price d-none d-sm-table-cell" style="text-wrap: nowrap;">
                                                        <template
                                                            v-if="(CART.code_cupon || CART.code_discount || CART.code_offer) && CART.discount > 0 && !CART.is_kit && !CART.is_pc_build">
                                                            <b class="color-oferta-cart">Oferta </b>
                                                        </template>
                                                        <span :class="{'is-hydrating': CART._hydrating}">${{ money(CART.subtotal) }}</span>

                                                        <template
                                                            v-if="(CART.code_cupon || CART.code_discount || CART.code_offer) && CART.discount > 0 && !CART.is_kit && !CART.is_pc_build">

                                                            <!-- <small class="sold-by" v-if="CART.code_offer">Oferta <span>{{ CART.code_offer }}</span> </small> -->
                                                            <br>
                                                            <!-- <small class="sold-by" v-if="CART.type_discount == 1">Descuento <span>- {{ CART.discount }} %</span> </small>
                                                        <br v-if="CART.type_discount == 1">
                                                        <small class="sold-by" v-if="CART.type_discount == 2">Descuento <span>- $ {{ CART.discount }} </span> </small>
                                                        <br v-if="CART.type_discount == 2"> -->
                                                            <small class="sold-by"> Antes <del><span> ${{
                                                                CART.price_unit }} </span></del> </small>
                                                            <!-- <br>
                                                        <small class="sold-by" v-if="CART.code_cupon && !CART.code_discount && !CART.code_offer">Cupon: <span>{{ CART.code_cupon }}</span> </small> -->
                                                            <!-- <small class="sold-by" v-if="CART.code_discount">Descuento: <span>{{ CART.code_discount }}</span> </small> -->
                                                        </template>
                                                    </td>
                                                    <td class="d-none d-lg-table-cell">
                                                        <div class="plus-minus">
                                                            <a href="javascript:void(0)" @click="minusCart(CART)"> <i
                                                                    class="sub" data-feather="minus"></i> </a>
                                                            <input
                                                                :disabled="(CART.code_cupon || CART.code_discount || CART.code_offer) && CART.discount > 0 && !CART.is_kit && !CART.is_pc_build"
                                                                pe="number" :value="CART.quantity"
                                                                @keyup="processQuantity(CART, $event)"
                                                                @keyup.enter="processQuantity(CART, $event)" min="1"
                                                                max="10" />
                                                            <a href="javascript:void(0)" @click="plusCart(CART)"> <i
                                                                    class="add" data-feather="plus"></i> </a>
                                                        </div>
                                                    </td>
                                                    <td class="total d-none d-xl-table-cell" style="text-wrap:nowrap;">$
                                                        <span :class="{'is-hydrating': CART._hydrating}">{{ money(CART.total) }}</span>
                                                        <template
                                                            v-if="CART.discount > 0 && !CART.is_kit && !CART.is_pc_build">
                                                            <br>
                                                            <b class="color-oferta-cart">Ahorro </b>
                                                            ${{ getDescountC(CART) }}
                                                        </template>
                                                    </td>
                                                    <td>
                                                        <a v-if="CART.is_pc_build || CART.is_kit" data-bs-toggle="modal"
                                                            data-bs-target="#viewCartDelete" class="remove-cart"
                                                            @click="removePcBuild(CART)"
                                                            style="color: white;background: #10121b;">
                                                            <i data-feather="x"></i>
                                                        </a>

                                                        <button v-if="!CART.is_pc_build && !CART.is_kit"
                                                            class="remove-cart" @click="removeCart(CART)"
                                                            style="color: white;background: #10121b;"><i
                                                                data-feather="x"></i></button>
                                                    </td>
                                                </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-5 col-lg-3">
                            <div class="summery-wrap">
                                <div class="coupon-box">
                                    <h5 class="cart-title"><i data-feather="tag"></i> Cupón</h5>
                                    <div class="text-wrap">
                                        <!-- <h4><i data-feather="tag"></i> Apply Coupon</h4> -->
                                        <div class="input-flex2" bis_skin_checked="1">
                                            <input class="form-control3 coupon-input" type="text"
                                                placeholder="Cupón....." name="coupon" v-model="code_cupon"
                                                v-on:keyup.enter="applyCupon"
                                                @input="code_cupon = code_cupon.replace(/[^A-Za-z0-9]/g, '')" />
                                            <button @click="applyCupon()" class="btn-green">Aplicar</button>
                                        </div>
                                    </div>

                                    <span v-if="groups_coupons.length > 0">Cupones Aplicados: </span>
                                    <template v-for="(groups_coup, index) in groups_coupons" :key="index">
                                        <p class="content-color font-md mb-0"> {{ groups_coup }} <a
                                                href="javascript:void(0)" @click="removeCoupon(groups_coup)"
                                                class="theme-color">X</a></p>
                                    </template>

                                </div>
                                <div class="cart-wrap grand-total-wrap">
                                    <div>
                                        <div class="order-summery-box">
                                            <h5 class="cart-title">Resumen: </h5>
                                            <ul class="order-summery">
                                                <li>
                                                    <span>Subtotal</span>
                                                    <span>$ {{ SUB_TOTAL_SUM.toFixed(2) }} </span>
                                                </li>

                                                <li>
                                                    <span>Descuento</span>
                                                    <span>$ {{ DESCUENTO_TOTAL_SUM.toFixed(2) }} </span>
                                                </li>

                                                <li class="pb-0">
                                                    <span>Total</span>
                                                    <span>$ {{ TOTAL_SUM.toFixed(2) }}</span>
                                                </li>
                                            </ul>
                                            <div class="row g-3 mt-2">
                                                <div class="col-6 col-md-12">

                                                    <router-link to="/checkout" class="btn-solid checkout-btn"
                                                        v-if="Number(TOTAL_SUM) > 0">Pagar <i
                                                            class="arrow"></i></router-link>

                                                </div>
                                                <div class="col-6 col-md-12">
                                                    <a href="/shop"
                                                        class="btn-outline w-100 justify-content-center checkout-btn">
                                                        Volver a
                                                        Tienda </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-b-space card-page" v-show="loader">
                <div class="loader_div">
                    <div class="loader">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </section>
            <!-- Cart Section End -->
        </main>
        <!-- Main End -->
        <ModalDeleteCart></ModalDeleteCart>
    </div>
</template>
<script>
import store from '../../plugins/store'
import myApi from '../../plugins/axios'
import CartResource from '../../resource/cart'
import { useMeta } from 'vue-meta'
import ModalDeleteCart from './modal/ModalDeleteCart.vue'
//import { replace } from 'core-js/fn/symbol'

export default {
    name: 'CartShop',
    data() {
        return {
            CARTS: [],
            TOTAL_SUM: 0,
            code_cupon: null,
            groups_coupons: [],
            sin_stock: null,
            products_process_sucursals: [],
            loadingSucursal: true,
            SUB_TOTAL_SUM: 0,
            DESCUENTO_TOTAL_SUM: 0,
            CART_SELECTED: null,
            loader: true,
            MAX_QTY: 100,
            hydratationTimer: null,
            reqId: 0,
            lastAppliedReq: 0,
            syncingFromServer: false,   
        }
    },
    components: {
        ModalDeleteCart,
    },
    methods: {
        
async validateBeforeApply(uniqd, desiredQty) {
    const minimal = this.CARTS.map(this.toMinimal);
    const idx = minimal.findIndex(m => String(m.uniqd) === String(uniqd));
    
    if (idx === -1) return { success: false };

    
    minimal[idx].quantity = this.clampQty(desiredQty);

    const payload = { 
        CARTS: minimal.map(m => ({ 
            uniqd: String(m.uniqd), 
            quantity: Number(m.quantity || 1) 
        })) 
    };

    try {
       
        const resp = await myApi.post('ecommerce/process_cart_sucursal', payload);
        
       
        return { success: true, data: resp.data };
        
    } catch (e) {
        
        if (e?.response?.status === 409) {
            const errorData = e?.response?.data?.error || {};
            const productos = e?.response?.data?.products || [];
            
            
            const problematicProduct = productos.find(
                p => String(p.uniqd) === String(uniqd)
            );

            if (problematicProduct) {
                const stockDisponible = Number(problematicProduct.quantity_sucursal || 0);
                
                if (desiredQty > stockDisponible) {
                    this.$notify({
                        title: 'Stock insuficiente',
                        text: `Solo hay ${stockDisponible} unidades disponibles`,
                        type: 'error',
                        duration: 4500,
                    });
                } else {
                    
                    this.$notify({
                        title: 'Límite alcanzado',
                        text: errorData || 'No se puede agregar más cantidad de este producto.',
                        type: 'error',
                        duration: 4500,
                    });
                }
            } else {
                this.$notify({
                    title: 'No disponible',
                    text: errorData || 'Este producto no está disponible actualmente.',
                    type: 'error',
                    duration: 4000,
                });
            }
            
            return { success: false, error: errorData };
        }
        

        this.$notify({
            title: 'Error de validación',
            text: 'No se pudo verificar la disponibilidad del producto.',
            type: 'error',
            duration: 3500,
        });
        return { success: false, error: e };
    }
},
        async hydrateCartIds() {
  try {
    // pide el carrito del usuario logueado
    const resp = await myApi.get("ecommerce/carts/");
    const rows = resp?.data?.carts?.data || [];

    // arma un diccionario uniqd -> cart_id
    const byUniqd = Object.fromEntries(
      rows.map(r => [ String(r.product?.uniqd || r.uniqd), r.id ])
    );

    // inyecta cart_id en lo que ya tienes en memoria
    this.CARTS.forEach(row => {
      const id = byUniqd[String(row.uniqd)];
      if (id) row.cart_id = id;   // <- clave
    });
  } catch (e) {
    console.log("hydrateCartIds error", e);
  }
},


        mergeMinimalLists(a = [], b = []) {
            const byId = new Map();
            const put = (item) => {
                if (!item || !item.uniqd) return;
                const id = String(item.uniqd);
                const qty = this.clampQty(item.quantity);
                const prev = byId.get(id);
                byId.set(id, { uniqd: id, quantity: this.clampQty((prev?.quantity || 0) + qty) });
            };
            (Array.isArray(a) ? a : []).forEach(put);
            (Array.isArray(b) ? b : []).forEach(put);
            return Array.from(byId.values());
        },

        mergeMinimalIntoView(list) {
            // A) normaliza a minimal {uniqd, quantity}
            const minimal = (Array.isArray(list) ? list : [])
                .filter(x => x && x.uniqd)
                .map(this.toMinimal);

            const qtyById = Object.fromEntries(minimal.map(m => [String(m.uniqd), this.clampQty(m.quantity)]));

            // B) cache de lo que ya está visible (con título/imagen/precios)
            const cache = Object.fromEntries(this.CARTS.map(row => [String(row.uniqd), row]));

            // C) construye el nuevo array de vista sin perder meta/precios previos
            const nextView = [];

            minimal.forEach(m => {
                const id = String(m.uniqd);
                const prev = cache[id];

                if (prev) {
                    // solo actualiza cantidad y total (optimista), conserva meta/precios
                    prev.quantity = qtyById[id];
                    this.updateRowTotals?.(prev);
                    nextView.push(prev);
                } else {
                    // si es un ítem nuevo: placeholder estable (sin huecos)
                    nextView.push({
                        uniqd: m.uniqd,
                        quantity: qtyById[id],
                        title: 'Cargando…',
                        slug: '',
                        imagen: '/assets/images/placeholder-product.png',
                        price_unit: 0,
                        subtotal: 0,
                        total: 0,
                        type_discount: 0,
                        discount: 0,
                        needsMeta: true,
                    });
                }
            });

            this.CARTS = nextView;
            this.recalcTotalsSoon?.();
        },

        // 🔽 dos líneas arriba (cualquier método tuyo)
    // Coalesce de cambios: junta múltiples +/− en 250ms
    scheduleServerSync() {
      clearTimeout(this._updTimer);
      this._updTimer = setTimeout(() => this._pushServerSync(), 250);
    },

    // Single-flight: mientras haya una sync en curso, marca que “falta otra”
    async _pushServerSync() {
      if (this._syncing) { this._needsAnother = true; return; }
      this._syncing = true;

      try {
        // 1) Tomar snapshot minimal
        const MIN = (this.CARTS || []).map(c => ({
          uniqd: String(c.uniqd),
          quantity: Number(c.quantity || 1),
        }));

        // 2) Server: actualizar cantidades
        await this.$myApi.post('ecommerce/update_cart', { cart: MIN });

        // 3) Emitir refresh global para que TODOS (Header incluido) relean del server
        this.emitter.emit('refres-cart-list');  // el Header ya tiene listener
      } catch (e) {
        this.$notify({ title: 'No se pudo actualizar el carrito', type: 'error', duration: 2200 });
      } finally {
        this._syncing = false;
        if (this._needsAnother) {
          this._needsAnother = false;
          this.scheduleServerSync(); // ejecuta la siguiente ronda
        }
      }
    },


        money(v) {
            const n = Number(v);
            return Number.isFinite(n) ? n.toFixed(2) : '0.00';
        },

        updateRowTotals(row) {
            // En tu modelo, "subtotal" es el precio unitario vigente (con descuento si aplica)
            const unit = Number(row.subtotal) || Number(row.price_unit) || 0;
            const qty = this.clampQty(row.quantity);
            row.total = unit * qty;
        },
        recalcTotalsSoon() {
            this.__totalsRaf && cancelAnimationFrame(this.__totalsRaf);
            this.__totalsRaf = requestAnimationFrame(() => {
                this.DESCUENTO_TOTAL_SUM = 0;
                this.SUB_TOTAL_SUM = 0;
                this.TOTAL_SUM = this.CARTS.reduce((sum, cart) => sum + Number(cart.total || 0), 0);
                this.CARTS.forEach((cart) => {
                    if (Number(cart.discount) > 0) {
                        this.DESCUENTO_TOTAL_SUM += (Number(cart.price_unit || 0) - Number(cart.subtotal || 0));
                    }
                    this.SUB_TOTAL_SUM += (Number(cart.price_unit || 0) * Number(cart.quantity || 1));
                });
            });
        },

        // Nueva funcion
        scheduleHydratation(delay = 250) {
            clearTimeout(this.hydratationTimer);
            this.hydratationTimer = setTimeout(() => {
                this.processCartSucursal();
            }, delay);
        },


        clampQty(raw) {
            let q = Math.floor(Number(raw || 1));
            if (!Number.isFinite(q)) q = 1;
            if (q < 1) q = 1;
            if (q > this.MAX_QTY) q = this.MAX_QTY;
            return q;
        },

        enforceMax(CART, e) {
            const clamped = this.clampQty(e?.target?.value);
            if (String(e.target.value) !== String(clamped)) {
                e.target.value = clamped; // corrige en vivo
            }
        },


        async safeUpdateQuantity(CART, nextQty) {
            const prevCarts = JSON.parse(JSON.stringify(this.CARTS)); // snapshot por si algo falla

            try {
                // 1) Optimismo local: ajusta cantidad y total YA
                const idx = this.CARTS.findIndex(p => String(p.uniqd) === String(CART.uniqd));
                if (idx !== -1) {
                    this.CARTS[idx].quantity = this.clampQty(nextQty);
                    this.updateRowTotals(this.CARTS[idx]);
                    this.$set ? this.$set(this.CARTS[idx], '_hydrating', true) : (this.CARTS[idx]._hydrating = true);
                }

                // 2) Persiste minimal + emite
                const MIN = this.CARTS.map(({ uniqd, quantity }) => ({ uniqd: String(uniqd), quantity: this.clampQty(quantity) }));
                // localStorage.setItem('carts_v2', JSON.stringify(MIN));
                if (!store.getters.loggedIn) localStorage.setItem('carts', JSON.stringify(MIN));
                this.emitter?.emit?.('cart-shop', { items: MIN, replace: true, source: 'cart'});

                // 3) Totales instantáneos
                this.recalcTotalsSoon();

                // 4) 🕒 En lugar de ir directo al back, agrupa varias pulsaciones:
                this.scheduleHydratation(250);

            } catch (err) {
                // Rollback si algo sale mal
                const errors = err?.response?.data?.errors || {};
                const flatMsg = Object.values(errors).flat?.()[0] || err?.response?.data?.message || 'Cantidad inválida';
                this.$notify({ title: flatMsg, type: 'error', duration: 3500 });

                this.CARTS = prevCarts;
                const MIN = prevCarts.map(({ uniqd, quantity }) => ({ uniqd: String(uniqd), quantity: this.clampQty(quantity) }));
                // localStorage.setItem('carts_v2', JSON.stringify(MIN));
                if (!store.getters.loggedIn) localStorage.setItem('carts', JSON.stringify(MIN));
                this.emitter?.emit?.('cart-shop', { items: MIN, replace: true, source: 'cart'});
                this.recalcTotalsSoon();
            }
        },



        getDescountC(CART) {
            if (CART.discount > 0) {
                return (CART.price_unit - CART.subtotal).toFixed(2);
            }
            return 0;
        },
   async minusCart(CART) {
    const curr = Number(CART.quantity || 1);
    if (curr <= 1) {
        this.$notify({ 
            title: 'Cantidad de producto no válida', 
            type: 'error', 
            duration: 3000 
        });
        return;
    }
    const next = this.clampQty(curr - 1);
    
    
    const validation = await this.validateBeforeApply(CART.uniqd, next);
    
    if (!validation.success) {
        return;
    }
    
    await this.safeUpdateQuantity(CART, next);
},


async plusCart(CART) {
    const curr = Number(CART.quantity || 1);
    const next = this.clampQty(curr + 1);
    
  
    const validation = await this.validateBeforeApply(CART.uniqd, next);
    
    if (!validation.success) {
       
        return; 
    }
    
    
    await this.safeUpdateQuantity(CART, next);
},


async processQuantity(CART, e) {
    
    const clamped = this.clampQty(e?.target?.value);
    if (String(e.target.value) !== String(clamped)) {
        e.target.value = clamped;
    }

   
    const idx = this.CARTS.findIndex(p => String(p.uniqd) === String(CART.uniqd));
    if (idx !== -1) {
        this.CARTS[idx].quantity = clamped;
        this.updateRowTotals(this.CARTS[idx]);
        this.$set ? this.$set(this.CARTS[idx], '_hydrating', true) : (this.CARTS[idx]._hydrating = true);
    }

   
    const MIN = this.CARTS.map(({ uniqd, quantity }) => ({ 
        uniqd: String(uniqd), 
        quantity: this.clampQty(quantity) 
    }));
    if (!this.$store.getters.loggedIn) {
        localStorage.setItem('carts', JSON.stringify(MIN));
        this.emitter?.emit?.('cart-shop', { items: MIN, replace: true, source: 'cart'});
    }

    this.recalcTotalsSoon();

    this.scheduleHydratation(250);
},


        removePcBuild(CART) {
            this.CART_SELECTED = CART;
            CART.is_cart_shop = true;
            this.emitter.emit("open-delete-cart", CART);
        },
        removeCart(CART) {
            // let CARTS = this.$cookies.get("carts") ? this.$cookies.get("carts") : [];
            let INDEX = this.CARTS.findIndex(product => product.uniqd == CART.uniqd);

            if (!store.getters.loggedIn) {

                if ((CART.is_pc_build || CART.is_kit) && CART.discount > 0) {
                    let CART_FORMAT = this.CARTS;
                    this.CARTS = [];
                    let index = 0;
                    for (const CARTR of CART_FORMAT) {
                        CARTR.type_discount = null;
                        CARTR.discount = 0;
                        CARTR.discount_old = null;
                        CARTR.type_discount_old = null;
                        CARTR.code_offer = null;
                        CARTR.subtotal = CARTR.price_unit;
                        CARTR.total = Number((CARTR.price_unit * CARTR.quantity).toFixed(2));
                        if (INDEX != index) {
                            this.CARTS.push(CARTR);
                        }
                        index++;
                    }
                } else {

                    if (INDEX != -1) {
                        this.CARTS.splice(INDEX, 1);
                    }
                }
                // this.$cookies.set('carts',this.CARTS);
                const minimal = this.CARTS.filter(x => x && x.uniqd).map(this.toMinimal);
                this.writeMinimalCart(minimal);
                this.$notify({
                    title: "Producto removido del carrito",
                    // text: `El producto '${CART.title}' se elimino del carrito correctamente!`,
                    type: 'error',
                    duration: 4500,
                });
                const snapshot = this.CARTS.filter(x => x && x.uniqd).map(this.toMinimal);
                this.emitter.emit('cart-shop', {items: snapshot, replace: true, source: 'cart'});
            } else {
                if (INDEX != -1) {
                    this.deleteCart(this.CARTS[INDEX], INDEX);
                }
            }
        },
        async deleteCart(data, index) {
            try {
                // Asegura cart_id por si vino sin él
                if (!data?.cart_id) {
                    await this.hydrateCartIds();
                    const refreshed = this.CARTS[index];
                    if (refreshed?.cart_id) data = refreshed;
                }

                if (!data?.cart_id) {
                    this.$notify({ title: "No se pudo identificar el ítem del carrito.", duration: 3500, type: "error" });
                    return;
                }

                const resp = await myApi.post(`ecommerce/carts/delete/${data.cart_id}`, { });

                if (resp?.data?.message == 203) {
                    // El servidor devuelve la lista completa normalizada:
                    // 1) reemplaza tu estado local (para evitar flashes)
                    const cartsNormalized = resp.data.CARTS || [];
                    this.CARTS = (cartsNormalized || []).map(this.sanitizeCartItem).map(m => ({
                        ...m, needsMeta: true, price_unit: 0, subtotal: 0, total: 0
                    }));
                    // 2) persiste minimal y emite snapshot con replace:true
                    const MIN = this.CARTS.map(this.toMinimal);
                    this.writeMinimalCart(MIN);
                    this.emitter.emit('cart-shop', { items: MIN, replace: true, source: 'cart' });
                } else {
                    // Borrado simple:
                    if (!Number.isInteger(index) || index < 0) {
                        index = this.CARTS.findIndex(x => String(x?.uniqd) === String(data?.uniqd));
                    }
                    if (index !== -1) this.CARTS.splice(index, 1);

                    const MIN = this.CARTS.map(this.toMinimal);
                    this.writeMinimalCart(MIN); // 👈 persiste SIEMPRE
                    this.emitter.emit('cart-shop', { items: MIN, replace: true, source: 'cart' });

                    this.$notify({ title: "Producto removido del carrito", type: "error", duration: 1000 });
                }

                // Rehidrata precios/meta sin persistir al server (para evitar rebotes)
                await this.processCartSucursal({ noPersist: true });
            } catch (error) {
                console.log(error);
                this.$notify({ title: "Error al eliminar", type: "error", duration: 2000 });
            }
        },


        // * Codemark Mods
        sanitizeCartItem(item) {
            return {
                uniqd: String(item.uniqd),
                quantity: this.clampQty(item.quantity),

            };
        },
        toMinimal(item) {
            return { uniqd: String(item.uniqd), quantity: Number(item.quantity || 1) };
        },
        readMinimalCart() {
            try {
                // const rawV2 = localStorage.getItem('carts_v2');
                // if (rawV2) {
                //     const arr = JSON.parse(rawV2);
                //     if (Array.isArray(arr)) return arr.map(this.toMinimal);
                // }
                // migración desde 'carts' (si quedó gordo)
                const raw = localStorage.getItem('carts');
                if (!raw) return [];
                const arr = JSON.parse(raw);
                if (!Array.isArray(arr)) return [];
                const min = arr.filter(x => x && x.uniqd).map(this.toMinimal);
                // pisa ambos con minimal
                // localStorage.setItem('carts_v2', JSON.stringify(min));
                if (!store.getters.loggedIn) localStorage.setItem('carts', JSON.stringify(min));
                return min;
            } catch { return []; }
        },
        writeMinimalCart(min) {
            // localStorage.setItem('carts_v2', JSON.stringify(min));
            // compat: si otras vistas leen 'carts', que vean el mismo minimal
            if (!store.getters.loggedIn) localStorage.setItem('carts', JSON.stringify(min));
        },

        async hydrateMetaFromServerByIds(ids) {
            if (!ids || ids.length === 0) return {};
            const resp = await myApi.post('ecommerce/products_meta', { ids });
            const list = resp?.data?.data || [];
            return Object.fromEntries(list.map(m => [String(m.uniqd), m]));
        },

        
        // * Codemark Helper Finish

        async applyCupon() {
            let data = {
                code_cupon: this.code_cupon,
                CARTS: this.CARTS.map(this.sanitizeCartItem)
            };
            // const resp = await myApi.post('ecommerce/apply_coupon', data);
            try {
                const resp = await myApi.post('ecommerce/apply_coupon', data);
                console.log('resp', resp)
                this.$notify({
                        title: resp.data.message_text,
                        type: 'success',
                        duration: 4500,
                })
                 this.emitter.emit("cart-shop", resp.data.CARTS);
            } catch (error) {
                if(error.response.status === 500) {
                       this.$notify({
                        title: error?.response.data?.message_text ?? 'ERROR INESPERADO',
                        type: 'error',
                        duration: 4500,
                })
                }else{
                       this.$notify({
                        title: error?.response.data?.message_text ?? 'ERROR INESPERADO',
                        type: 'warn',
                        duration: 4500,
                })
                }

            }
            // console.log('resp data cupon', resp)

            // if (resp.data.error) {
            //     for (let key in resp.data.error) {
            //         this.$notify({
            //             title: "VALIDACIÓN",
            //             text: resp.data.error[key],
            //             duration: 1000,
            //             type: 'error',
            //         });
            //     }
            // } else {
            //     console.log(resp);
            //     if (resp.data.message == 404) {
            //         this.$notify({
            //             // title: "CUPON",
            //             title: resp.data.message_text,
            //             type: 'error',
            //             duration: 4500,
            //         });
            //     } else {
            //         console.log(resp);
            //         if (!store.getters.loggedIn) {
            //             // this.$cookies.set('carts',resp.data.CARTS);
            //             //localStorage.setItem('carts', JSON.stringify(resp.data.CARTS));
            //             const minimal = (resp.data.CARTS || []).filter(x => x && x.uniqd).map(this.toMinimal);
            //             this.writeMinimalCart(minimal);
            //         }
            //         let APPLY_C = resp.data.CARTS.find(item => item.code_cupon == this.code_cupon && !item.code_discount)
            //         if (APPLY_C) {
            //             this.groups_coupons.push(this.code_cupon);
            //         }
            //         this.code_cupon = null;
            //         this.$notify({
            //             title: "EL CUPON SE APLICO CORRECTAMENTE",
            //             // text: ``,
            //             duration: 4500,
            //         });
            //         this.emitter.emit("cart-shop", resp.data.CARTS);
            //     }
            // }
        },
        removeCoupon(groups_coup) {
            let INDEX = this.groups_coupons.findIndex(item => item == groups_coup);
            if (INDEX != -1) {
                this.groups_coupons.splice(INDEX, 1);
            }
            CartResource.deleteCoupon(this.CARTS, groups_coup, this.emitter, this.$notify, this.$cookies)
        },
        isNotStockProduct(CART) {
            let PROCESS_SUCURSAL = this.products_process_sucursals.find(item => item.uniqd == CART.uniqd);
            if (PROCESS_SUCURSAL) {
                return "Producto fuera de stock por el momento";//"Solo hay "+ PROCESS_SUCURSAL.quantity_sucursal + (PROCESS_SUCURSAL.quantity_sucursal > 1 ? " unidades " : " unidad ")  +"de este producto disponible";
            }
            return false;
        },
        async processCartSucursal(opts = {}) {
            const noPersist = !!opts.noPersist; // 👈 nuevo
            try {
                // 0) Salida limpia si no hay items
                if (!Array.isArray(this.CARTS) || this.CARTS.length === 0) {
                    this.loadingSucursal = true;
                    this.loader = false;
                    this.TOTAL_SUM = this.SUB_TOTAL_SUM = this.DESCUENTO_TOTAL_SUM = 0;
                    if (!store.getters.loggedIn) localStorage.setItem('carts', '[]');
                    // localStorage.setItem('carts_v2', '[]');
                    return;
                }

                this.loadingSucursal = false;

                // Snapshot de la UI actual para NO perder imagen/slug/precio
                const uiCacheById = Object.fromEntries(this.CARTS.map(c => [String(c.uniqd), c]));

                // 1) Llamada al backend
                const payload = { CARTS: this.CARTS.map(this.sanitizeCartItem) };
                let data;
                try {
                    const resp = await myApi.post('ecommerce/process_cart_sucursal', payload);
                    data = resp.data; // ← usamos "data" desde aquí
                } catch (err) {
                    // Si el servidor respondió con HTTP 409 (stock insuficiente), igualmente usamos su data
                    if (err?.response?.status === 409) {
                        data = err.response.data; // { message:409, products, precios, meta }
                    } else {
                        throw err; // otros errores sí se manejan abajo en el catch grande
                    }
                }

                this.loadingSucursal = true;

                // 2) Caso "no hay sucursales": mostramos y NO rompemos UI (pero salimos)
                if (data?.message == 403) {
                    this.$notify({
                        title: 'No hay sucursales disponibles para este carrito.',
                        type: 'error',
                        duration: 3500
                    });
                    return;
                }

                // 3) Caso stock insuficiente (409 moderno o 500 legacy)
                if (data?.message == 409 || data?.message == 500) {
                    const outs = data?.products || [];
                    // Ajustar cantidades al máximo disponible (mínimo 1 para no romper inputs)
                    outs.forEach(p => {
                        const idx = this.CARTS.findIndex(x => String(x.uniqd) === String(p.uniqd));
                        if (idx !== -1) {
                            const max = Number(p.quantity_sucursal || 0);
                            this.CARTS[idx].quantity = Math.max(1, max);
                        }
                    });

                    this.$notify({
                        title: 'Ajustamos cantidades al stock disponible',
                        duration: 4500,
                        type: 'warn',
                    });
                    // Importante: NO retornamos. Seguimos para hidratar con precios/meta
                    // que vienen en la misma respuesta 409/500.
                }

                // 4) Hidratar SIEMPRE con precios + meta (vengan de 200/409/500)
                const precios = data?.precios || [];
                const meta = data?.meta || [];

                // Diccionarios por uniqd
                const byPrice = Object.fromEntries(
                    precios.map(p => [String(p.uniqd ?? p.id_prod), p])
                );
                const byMeta = Object.fromEntries(
                    meta.map(m => [String(m.uniqd), m])
                );

                // 5) Reconstruir carrito mezclando UI previa (fallbacks) para NO perder nada visual
                const newPriceLocal = this.CARTS.map((cart) => {
                    const key = String(cart.uniqd);
                    const p = byPrice[key] || {};
                    const m = byMeta[key] || {};
                    const prev = uiCacheById[key] || {};

                    const price = Number(p.precio ?? p.price ?? prev.price_unit ?? 0);
                    const d = p.descuento ?? null;

                    const percentage = Number(d?.percentage ?? prev.discount ?? 0);
                    const newAmount = Number(d?.new_amount ?? price);
                    const quantity = Number(cart.quantity) || 1;

                    // Subtotal con guardas (evita NaN)
                    const subtotal = Number.isFinite(newAmount)
                        ? newAmount
                        : (prev.subtotal ?? 0);

                    return {
                        // Mezcla meta/UI para título/slug/imagen
                        title: m.title || prev.title || '',
                        slug: m.slug || prev.slug || '',
                        imagen: m.imagen || m.image_url || prev.imagen || '/assets/images/placeholder-product.png',

                        uniqd: cart.uniqd,
                        quantity,
                        price_unit: Number.isFinite(price) ? price : (prev.price_unit ?? 0),
                        subtotal,
                        total: subtotal * quantity,

                        type_discount: d ? 1 : (prev.type_discount ?? 0),
                        type_discount_old: d ? 1 : (prev.type_discount_old ?? 0),
                        discount: percentage,
                        discount_old: percentage,
                        code_discount: d?.code ?? (prev.code_discount ?? 0),
                        code_offer: d?.code ?? (prev.code_offer ?? 0),
                    };
                });

                // ❌ Antes reemplazabas el array completo (causa flash):
                // this.CARTS = newPriceLocal;

                const patchById = Object.fromEntries(newPriceLocal.map(i => [String(i.uniqd), i]));
                this.CARTS.forEach((row) => {
                    const patch = patchById[String(row.uniqd)];
                    if (!patch) return;

                    const mustHydrate = row.needsMeta || !row.title || !row.slug || !row.imagen;

                    if (mustHydrate) {
                        if (patch.title) row.title = patch.title;
                        if (patch.slug) row.slug = patch.slug;
                        if (patch.imagen) row.imagen = patch.imagen;
                        row.needsMeta = false; 
                    }

                    // volátiles
                    row.quantity = patch.quantity;
                    row.price_unit = patch.price_unit;
                    row.subtotal = patch.subtotal;
                    row.total = patch.total;
                    row.type_discount = patch.type_discount;
                    row.type_discount_old = patch.type_discount_old;
                    row.discount = patch.discount;
                    row.discount_old = patch.discount_old;
                    row.code_discount = patch.code_discount;
                    row.code_offer = patch.code_offer;
                });


                // 6) Guardado local minimal y versión segura
                const MINIMAL_CART = this.CARTS.map(({ uniqd, quantity }) => ({ uniqd: String(uniqd), quantity: Number(quantity || 1) }));
                // localStorage.setItem('carts_v2', JSON.stringify(MINIMAL_CART));
                if (!store.getters.loggedIn) localStorage.setItem('carts', JSON.stringify(MINIMAL_CART)); // compat

                // 7) Si el user está logueado, sincronizas server-side
                if (store.getters.loggedIn && !noPersist) {
                    await myApi.post('ecommerce/update_cart', { cart: MINIMAL_CART });
                    //await this.hydrateCartIds();
                    //this.emitter?.emit?.('refres-cart-list', {});
                }

                // 8) Recalcular sumas con guardas (evita NaN)
                this.DESCUENTO_TOTAL_SUM = 0;
                this.SUB_TOTAL_SUM = 0;
                this.TOTAL_SUM = this.CARTS.reduce((sum, cart) => sum + Number(cart.total || 0), 0);
                this.CARTS.forEach((cart) => {
                    if (Number(cart.discount) > 0) {
                        this.DESCUENTO_TOTAL_SUM += (Number(cart.price_unit || 0) - Number(cart.subtotal || 0));
                    }
                    this.SUB_TOTAL_SUM += (Number(cart.price_unit || 0) * Number(cart.quantity || 1));
                });

                // 9) Feather (lo mantienes tal cual)
                setTimeout(() => {
                    const script2 = document.createElement('script');
                    script2.src = '../../assets/js/feather/feather.min.js';
                    document.body.appendChild(script2);
                    script2.onload = () => {
                        // console.log('Feather ok');
                    }
                }, 50);

                this.loader = false;

                // 10) Metadatos (lo mantienes tal cual)
                this.useMetaT.meta = [
                    { name: 'description', content: `Tienes ${this.CARTS.length} productos en el carrito` },
                    { property: 'og:title', content: 'Mi Carrito - Zona Digital' },
                    { property: 'og:description', content: `Subtotal: $${this.SUB_TOTAL_SUM.toFixed(2)}` },
                    { property: 'og:image', content: this.CARTS[0]?.imagen || '/assets/default-cart.png' }
                ];

            } catch (error) {
                console.log(error);
                // IMPORTANTE: NO limpies this.CARTS aquí, así no pierdes UI si algo falla
                this.$notify({
                    title: "Hubo un error a nivel interno, comuníquese con el soporte de la página",
                    duration: 3000,
                    type: 'error',
                });
            }
        },



        initCarst() {
            //let CARTS = localStorage.getItem('carts') ? JSON.parse(localStorage.getItem('carts')) : [];//this.$cookies.get("carts") ? this.$cookies.get("carts") : [];
            const min = this.readMinimalCart();
            this.mergeMinimalIntoView(min);
        },
async listCarts() {
    try {
        this._serverSyncLock = true; 
        

        const resp = await myApi.get("ecommerce/carts/");
        let serverCarts = [];

        (resp?.data?.carts?.data || []).forEach(cart => {
            serverCarts.push(CartResource.update(cart));
        });

       
        const MIN = serverCarts.map(c => ({ 
            uniqd: String(c.uniqd), 
            quantity: Number(c.quantity || 1) 
        }));

       
        try {
            const payload = { CARTS: MIN };
            const priceResp = await myApi.post('ecommerce/process_cart_sucursal', payload);
            
            if (priceResp.data?.message == 403) {
                
                this.CARTS = [];
                this.loader = false;
                this._serverSyncLock = false;
                return;
            }

            const precios = priceResp.data?.precios || [];
            const meta = priceResp.data?.meta || [];

            const byPrice = Object.fromEntries(
                precios.map(p => [String(p.uniqd ?? p.id_prod), p])
            );
            const byMeta = Object.fromEntries(
                meta.map(m => [String(m.uniqd), m])
            );

            
            this.CARTS = serverCarts.map(cart => {
                const key = String(cart.uniqd);
                const p = byPrice[key] || {};
                const m = byMeta[key] || {};

                const price = Number(p.precio ?? cart.price_unit ?? 0);
                const d = p.descuento ?? null;
                const newAmount = Number(d?.new_amount ?? price);
                const quantity = Number(cart.quantity || 1);

                return {
                    ...cart,
                    title: m.title || cart.title || '',
                    slug: m.slug || cart.slug || '',
                    imagen: m.imagen || m.image_url || cart.imagen || '/assets/images/placeholder-product.png',
                    price_unit: price,
                    subtotal: newAmount,
                    total: newAmount * quantity,
                    quantity,
                    discount: Number(d?.percentage ?? 0),
                    code_discount: d?.code ?? null,
                    code_offer: d?.code ?? null,
                };
            });

        } catch (e) {
            console.error('[Cart] Error hidratando precios:', e);
            this.CARTS = serverCarts;
        }

       
        this.recalcTotalsSoon();

       
        const snapshot = this.CARTS.map(c => ({ 
            uniqd: String(c.uniqd), 
            quantity: Number(c.quantity || 1) 
        }));
        
        
        setTimeout(() => {
            this.emitter.emit('cart-shop', { 
                items: snapshot, 
                replace: true, 
                source: 'server' 
            });
            this._serverSyncLock = false; 
        }, 50);

       
        this.groups_coupons = resp.data.groups_coupons || [];
        this.emitter.emit("groups_coupons", this.groups_coupons);

        this.loader = false;
       

    } catch (e) {
        console.error('[Cart] Error en listCarts:', e);
        
        this.loader = false;
        this._serverSyncLock = false;
    }
}
        
        
    },
    created() {
        this.sin_stock = this.$route.query.sin_stock;
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.initCarst();
        });
    },
mounted() {
    this.useMetaT = useMeta({
        title: 'Mi Carrito',
        htmlAttrs: { lang: 'en', amp: true },
        meta: [],
    });

    this._syncing = false;
    this._needsAnother = false;
    this._serverSyncLock = false;

    
    if (this.$store.getters.loggedIn) {
        this.loader = true;
        this.listCarts();
    } else {
        this.initCarst();  
        this.TOTAL_SUM = 0;
        this.SUB_TOTAL_SUM = 0;
        this.DESCUENTO_TOTAL_SUM = 0;
        this.processCartSucursal(); 
    }

  
    this.emitter.on('cart-shop', async (payload) => {
        
        if (this._serverSyncLock) {
            return;
        }

        const isObj = payload && typeof payload === 'object' && !Array.isArray(payload);
        const incomingRaw = isObj ? (payload.items || []) : (Array.isArray(payload) ? payload : []);
        const incoming = (incomingRaw || []).filter(x => x && x.uniqd).map(this.toMinimal);
        const source = isObj ? payload.source : null;

        if (this.$store.getters.loggedIn && source !== 'server') {
            return;
        }
        if (source === 'server') {
            this._serverSyncLock = true;
        }

      
        if (!this.$store.getters.loggedIn) {
            this.writeMinimalCart(incoming);
        }

        
        this.mergeMinimalIntoView(incoming);

        await this.processCartSucursal({ noPersist: (source === 'server') });

    
        this.syncGroupsCouponsFromCarts?.();
        if (source === 'server') {
            setTimeout(() => { this._serverSyncLock = false; }, 100);
        }
    });

 
    this.emitter.on('groups_coupons', data => {
        this.groups_coupons = data;
    });

    this.emitter.on('add-error-cart-shop', data => {
        this.$notify({ title: data, duration: 4500, type: 'error' });
    });

    this.emitter.on('acept-terminos', () => {
        this.removeCart(this.CART_SELECTED);
    });

    if (!this.$store.getters.loggedIn) {
        setTimeout(() => {
            this.emitter.emit('cart-list', {});
        }, 150);
    }
}
}
</script>

<style>
.is-hydrating { opacity: .55; transition: opacity .2s ease; }
</style>